import { render, staticRenderFns } from "./dashboardCO.vue?vue&type=template&id=781336ba&scoped=true"
import script from "./dashboardCO.vue?vue&type=script&lang=js"
export * from "./dashboardCO.vue?vue&type=script&lang=js"
import style0 from "./dashboardCO.vue?vue&type=style&index=0&id=781336ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781336ba",
  null
  
)

export default component.exports